export interface IImprovementFilters {
  search: string
  status: string[]
  stages: string[]
  departments: string[]
  creators: string[]
  coordinators: string[]
  suggestion_types: string[]
  created_after: Date | null
  created_before: Date | null
  decision_after: Date | null
  decision_before: Date | null
  mine: boolean
  my_department: boolean
  requires_action?: boolean | null
  page_size?: number
}

export function getEmptyImprovementFilters(): IImprovementFilters {
  return {
    search: '',
    status: [],
    stages: [],
    departments: [],
    creators: [],
    coordinators: [],
    suggestion_types: [],
    created_after: null,
    created_before: null,
    decision_after: null,
    decision_before: null,
    mine: false,
    my_department: false,
    requires_action: null,
    page_size: 25,
  }
}
